<template>
  <div v-if="blok.description.content[0]?.content" class="description" v-html="useRenderRichText(blok.description)"></div>
  <div class="form-builder-group">  
    <div
      v-for="(field) in blok.two_columns"
      :key="field._uid"
      class="form-builder-group-item"
    >
      <StoryblokComponent
        :blok="field"
        :is-myself="isMyself"
        :updated-value="updatedValue"
        @is-disabled-submit="emit('isDisabledSubmit')"
        @is-enabled-submit="emit('isEnabledSubmit')"
        @is-myself="emit('isMyself', $event)"
        @select-value="emit('selectValue', $event)"
       />
    </div>
  </div>
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    required: true,
  },
  isMyself: {
    type: Boolean,
    required: false,
    default: false,
  },
  updatedValue: {
    type: [Array, Object],
    required: false,
    default: null,
  },
});

const emit = defineEmits([
  "isDisabledSubmit",
  "isEnabledSubmit",
  "isMyself",
  "selectValue",
]);
</script>

<style lang="scss" scoped>
$field-gap: 0.625rem;

.description {
  margin-top: 2rem;
  margin-bottom: $field-gap;
}
.form-builder-group {
  margin-bottom: $field-gap;

  @include for-tablet-landscape-up {
    display: flex;
    justify-content: space-between;
  }
}
.form-builder-group-item {
  margin-bottom: $field-gap;

  @include for-tablet-landscape-up {
    width: calc(50% - $field-gap / 2);
    margin-bottom: 0;
  }

  &:first-child {
    z-index: 1;
  }
}
</style>
